import moment from 'moment'
import _ from 'lodash'

/**
 * Filter add comma as number divider
 * @param value - sorce value received from interpolated HTML element
 * @param decimalDigitsNumber number  of decimal places
 * @returns {string|*}
 */
const commaDividedNumber = function (value, decimalDigitsNumber) {
  if (!value && value !== 0) {
    return ''
  }
  if (Array.isArray(value) || isNaN(Number(value))) {
    return value
  }
  value = value.toString()
  const split = value.split('.')
  const integer = split[0]
  let fractional = split[1] ? `${split[1]}` : ''
  if (fractional) {
    if (decimalDigitsNumber || decimalDigitsNumber === 0) {
      fractional = fractional.length > decimalDigitsNumber ? fractional.slice(0, decimalDigitsNumber) : fractional
    }
    fractional = `.${fractional}`
  }
  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return `${formattedInteger}${fractional}`
}
/**
 * Filter for formatting time
 * @param value - sorce value received from interpolated HTML element
 * @param format @see https://momentjs.com/docs/#/parsing/string-format/
 * @returns {string|*}
 */
const formattedTime = function (value, format) {
  if (!value) {
    return
  }
  value = value.toString()
  format = format || 'h:mm A'
  if (!moment(value, moment.ISO_8601).isValid()) {
    return value
  }
  return moment(value).format(format)
}

/**
 * Filter for formatting date
 * @param value - sorce value received from interpolated HTML element
 * @param format @see https://momentjs.com/docs/#/parsing/string-format/
 * @returns {string|*}
 */
const formattedDate = function (value, format) {
  if (!value) {
    return
  }
  value = value.toString()
  format = format || 'MMM DD, YYYY' // formatted date will look like ‘Jan. 12-2018’
  if (!moment(value, moment.ISO_8601).isValid()) {
    return value
  }
  return moment(value).format(format)
}
/**
 * Filter for rounding numbers with fractional part
 * @param value - sorce value received from interpolated HTML element
 * @param decimalNumber fractional part length
 * @returns {string|*}
 */
const roundNumber = function (value, decimalNumber) {
  if (!_.isNumber(value)) {
    return value
  }
  if (decimalNumber) {
    return Math.round(value * 10 * decimalNumber) / (decimalNumber * 10)
  } else {
    return Math.round(value)
  }
}

const truncateLabel = function (value, labelLength = 12) {
  if (value.length <= labelLength) {
    return value
  }
  const separatePoint = Math.round(labelLength / 3)
  return `${value.substring(0, separatePoint)}...${value.substring(value.length - separatePoint - 3)}`
}

const absValue = (value) => {
  const newValue = Number(value)
  if (!_.isNumber(newValue) || Number.isNaN(newValue)) {
    return value
  }
  return Math.abs(newValue)
}

export default {
  commaDividedNumber,
  formattedTime,
  formattedDate,
  roundNumber,
  truncateLabel,
  absValue
}
